import {fsa, fsaError, fsaPayload} from '../helpers'

export const GET_SHOWROOM_APPOINTMENT_SERVICES = 'get showroom appointment services request'
export const getShowroomAppointmentServices = fsa(GET_SHOWROOM_APPOINTMENT_SERVICES)

export const CLEAR_SHOWROOM_APPOINTMENT_SERVICES = 'clear showroom appointment services'
export const clearShowroomAppointmentServices = fsa(CLEAR_SHOWROOM_APPOINTMENT_SERVICES)

export const GET_SHOWROOM_APPOINTMENT_SERVICES_PENDING =
  'get showroom appointment services request pending'
export const getShowroomAppointmentServicesPending = fsaPayload(
  GET_SHOWROOM_APPOINTMENT_SERVICES_PENDING,
)

export const GET_SHOWROOM_APPOINTMENT_SERVICES_SUCCESS = 'get showroom appointment services success'
export const getShowroomAppointmentServicesSuccess = fsaPayload(
  GET_SHOWROOM_APPOINTMENT_SERVICES_SUCCESS,
)

export const GET_SHOWROOM_APPOINTMENT_SERVICES_FAILURE = 'get showroom appointment services failure'
export const getShowroomAppointmentServicesFailure = fsaError(
  GET_SHOWROOM_APPOINTMENT_SERVICES_FAILURE,
)
